module.exports = __webpack_public_path__ + "img/banner_9.ee21534e.png";